export default __webpack_public_path__ + "static/media/Indian_Rupee.c63c1d09.svg";